import {
    Box,
    Container,
    Grid,
    Typography,
} from "@mui/material";

import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";

import { motion } from "framer-motion";


// =========================================================
// CONFIGURACIÓN VISUAL DE LAS CATEGORÍAS
// =========================================================

const configuracionCategorias = {
    1: {
        color: "#8F1515",
        icono: <SchoolRoundedIcon />,
    },

    2: {
        color: "#133E7C",
        icono: <MenuBookRoundedIcon />,
    },

    3: {
        color: "#22A39F",
        icono: <WorkspacePremiumRoundedIcon />,
    },
};


// =========================================================
// COMPONENTE
// =========================================================

export const TabsNivel = ({
    categorias = [],
    nivel,
    setNivel,
}) => {

    return (
        <Container
            maxWidth="xl"
            sx={{
                mt: {
                    xs: -2,
                    sm: -3,
                    md: -6,
                },

                px: {
                    xs: 2,
                    sm: 3,
                    md: 4,
                },

                position: "relative",
                zIndex: 10,
            }}
        >

            <Grid
                container
                spacing={{
                    xs: 2,
                    sm: 2.5,
                    md: 2,
                }}
            >

                {categorias.map((categoria, index) => {

                    const activo =
                        nivel === categoria.id;

                    const config =
                        configuracionCategorias[categoria.id] || {
                            color: "#3157A4",
                            icono: <SchoolRoundedIcon />,
                        };


                    return (

                        <Grid
                            key={categoria.id}
                            size={{
                                xs: 12,
                                sm: 4,
                                md: 4,
                            }}
                        >

                            <Box
                                component={motion.div}

                                initial={{
                                    opacity: 0,
                                    y: 40,
                                }}

                                whileInView={{
                                    opacity: 1,
                                    y: 0,
                                }}

                                transition={{
                                    duration: 0.6,
                                    delay: index * 0.15,
                                }}

                                viewport={{
                                    once: false,
                                }}

                                whileHover={{
                                    y: {
                                        xs: 0,
                                        md: -8,
                                    },
                                }}

                                onClick={() =>
                                    setNivel(categoria.id)
                                }

                                sx={{
                                    cursor: "pointer",

                                    position: "relative",

                                    bgcolor: "#fff",

                                    borderRadius: {
                                        xs: "20px",
                                        sm: "22px",
                                        md: "28px 28px 0 0",
                                    },

                                    minHeight: {
                                        xs: 95,
                                        sm: 110,
                                        md: 130,
                                    },

                                    px: {
                                        xs: 2,
                                        sm: 2.5,
                                        md: 4,
                                    },

                                    py: {
                                        xs: 2,
                                        sm: 2.5,
                                        md: 3,
                                    },

                                    display: "flex",

                                    alignItems: "center",

                                    gap: {
                                        xs: 1.8,
                                        sm: 2,
                                        md: 3,
                                    },

                                    transition: "all .35s ease",

                                    border: "1px solid #ECECEC",

                                    boxShadow: activo
                                        ? "0 18px 45px rgba(0,0,0,.10)"
                                        : "0 8px 25px rgba(0,0,0,.05)",

                                    overflow: "hidden",

                                    "&:hover": {
                                        boxShadow:
                                            "0 20px 50px rgba(0,0,0,.12)",
                                    },
                                }}
                            >

                                {/* ================================
                                    ICONO
                                ================================= */}

                                <Box
                                    sx={{
                                        width: {
                                            xs: 48,
                                            sm: 54,
                                            md: 60,
                                        },

                                        height: {
                                            xs: 48,
                                            sm: 54,
                                            md: 60,
                                        },

                                        minWidth: {
                                            xs: 48,
                                            sm: 54,
                                            md: 60,
                                        },

                                        borderRadius: "50%",

                                        bgcolor: config.color,

                                        display: "flex",

                                        alignItems: "center",

                                        justifyContent: "center",

                                        color: "#fff",

                                        flexShrink: 0,

                                        transition: ".3s",

                                        transform: activo
                                            ? "scale(1.08)"
                                            : "scale(1)",

                                        "& svg": {
                                            fontSize: {
                                                xs: "1.6rem",
                                                sm: "1.8rem",
                                                md: "2rem",
                                            },
                                        },
                                    }}
                                >
                                    {config.icono}
                                </Box>


                                {/* ================================
                                    TEXTO
                                ================================= */}

                                <Box
                                    sx={{
                                        minWidth: 0,
                                        flex: 1,
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            fontSize: {
                                                xs: "0.72rem",
                                                sm: "0.8rem",
                                                md: "1rem",
                                            },

                                            color: config.color,

                                            fontWeight: 500,

                                            fontFamily: "Archivo",

                                            letterSpacing: {
                                                xs: "0.3px",
                                                md: "0.5px",
                                            },
                                        }}
                                    >
                                        Educación
                                    </Typography>


                                    <Typography
                                        sx={{
                                            fontSize: {
                                                xs: "1.45rem",
                                                sm: "1.7rem",
                                                md: "2.1rem",
                                            },

                                            fontWeight: 700,

                                            color: config.color,

                                            lineHeight: 1.1,

                                            fontFamily: "Archivo",

                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {categoria.name}
                                    </Typography>

                                </Box>


                                {/* ================================
                                    INDICADOR ACTIVO
                                ================================= */}

                                <Box
                                    component={motion.div}
                                    layout
                                    sx={{
                                        position: "absolute",

                                        left: 0,

                                        bottom: 0,

                                        width: "100%",

                                        height: {
                                            xs: 4,
                                            md: 5,
                                        },

                                        bgcolor: activo
                                            ? config.color
                                            : "transparent",

                                        borderBottomLeftRadius: 8,

                                        borderBottomRightRadius: 8,

                                        transition: ".3s",
                                    }}
                                />

                            </Box>

                        </Grid>
                    );
                })}

            </Grid>
        </Container>
    );
};